import React from 'react';
import { ApiProvider } from './src/context/Api';
import { GlobalProvider } from './src/context/Global';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const wrapRootElement = _ref => {
  let {
    element
  } = _ref;
  return ___EmotionJSX(ApiProvider, null, ___EmotionJSX(GlobalProvider, null, element));
};